import { http } from "../base"

/**
 * 提交人工客服请求
 * @param {Object} data - 人工客服请求数据
 * @returns {Promise}
 */
export async function sendHumanServiceRequest(data) {
  console.log("发送人工客服请求:", data)
  
  try {
    const response = await http.post(
      '/aics/human-service/request',
      data,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    
    console.log("人工客服请求响应:", response.data)
    return response.data
    
  } catch (error) {
    console.error("发送人工客服请求失败:", error)
    throw error
  }
}

/**
 * 验证短信验证码
 * @param {string} phone - 手机号
 * @param {string} code - 验证码
 * @returns {Promise}
 */
export async function verifySMSCode(phone, code) {
  try {
    const response = await http.post(
      '/aics/human-service/verify-sms',
      { phone, code }
    )
    return response.data
  } catch (error) {
    console.error("验证短信验证码失败:", error)
    throw error
  }
}

/**
 * 获取人工客服历史记录
 * @param {Object} params - 查询参数
 * @returns {Promise}
 */
export async function getHumanServiceHistory(params = {}) {
  try {
    const response = await http.get(
      '/aics/human-service/history',
      { params }
    )
    return response.data
  } catch (error) {
    console.error("获取人工客服历史失败:", error)
    throw error
  }
}